export default __webpack_public_path__ + "static/media/ceta.82ea009d.svg";